import styled from "styled-components";
import { CSSProperties } from "react";
import { MOBILE_MENU } from "common/constants";

interface OrderNumberProps {
  displayNumber: number;
  size?: "s" | "l";
  style?: CSSProperties;
}

const OrderNumber = ({
  displayNumber,
  size = "s",
  style,
}: OrderNumberProps) => {
  return (
    <Wrapper $isLarge={size === "l"} style={style}>
      <span>{displayNumber}</span>
    </Wrapper>
  );
};

export const Wrapper = styled.div<{ $isLarge: boolean }>`
  flex: none;
  border: ${(p) => p.theme.borders.medium};
  color: ${(p) => p.theme.colors.secondaryText};
  font-size: ${(p) => (p.$isLarge ? 14 : 10)}px;
  height: ${(p) => (p.$isLarge ? 24 : 16)}px;
  width: ${(p) => (p.$isLarge ? 24 : 16)}px;
  border-radius: 50%;
  margin-right: ${(p) => (p.$isLarge ? 16 : 8)}px;
  position: relative;
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -48%);
  }
  @media (max-width: ${MOBILE_MENU}) {
    margin-right: 8px;
  );
`;

export default OrderNumber;
